module.exports = __webpack_public_path__ + "static/media/movieFinder.1099d734.png";